export const deepCopy = <Obj, Arr = Obj extends Array<infer ArrayType> ? ArrayType : never>(source: Obj): Obj => {
  if (Array.isArray(source)) {
    return source.map((item) => deepCopy(item)) as Obj & Arr[];
  }

  if (source instanceof Date) {
    return new Date(source.getTime()) as Obj & Date;
  }

  if (source && typeof source === 'object') {
    return (Object.getOwnPropertyNames(source) as (keyof Obj)[]).reduce<Obj>((o, prop) => {
      Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop)!);
      o[prop] = deepCopy(source[prop]);
      return o;
    }, Object.create(Object.getPrototypeOf(source)));
  }

  return source;
};
